import styled from '@emotion/styled'
import { Card, alpha } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'
import { Link } from 'react-router-dom'

export const CardsContainer = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  justify-content: center;
`

export const StyledCard = styled(Card)`
  width: 312px;
  height: 268px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: rgb(232, 243, 255, 50%);
  box-shadow: none;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
`

export const CardTag = styled.div`
  ${typography.down2.regularSans};
  color: ${colors.primary.main};
  font-size: 13px;
  line-height: 18px;
`

export const CardTitle = styled.h4`
  ${typography.up2.regularSans};
  color: ${colors.copy.headerDark};
  margin: 0;
`

export const CardDescription = styled.p`
  ${typography.down1.regularSans};
  color: ${colors.copy.paragraphDark};
  margin: 0;
  flex-grow: 1;
`

export const LinkButton = styled(Link)`
  text-decoration: none;

  & button {
    padding: 6px 16px;
    p {
      font-size: 13px;
      line-height: 18px;
    }
  }
`

export const ExploreLink = styled(Link)`
  ${typography.baseline.regularSans}
  font-size: 13px;
  line-height: 18px;
  align-self: flex-end;
  color: ${colors.primary.main};
  text-decoration: none;
  margin-top: 8px;
`
